import React, { useState } from 'react'
import {  useSelector } from "react-redux";

function NewCorousel({handleMouseEnter,handleMouseLeave,item,hoverRef,lowestOrderImage,transfer}) {
    const [activecls,setactivecls] = useState("")

    const { bgColor, textColor } = useSelector((state) => state.theam);
  return (
    <div 
    // onMouseEnter={()=>{handleMouseEnter(item?.id)}}
    // onMouseLeave={handleMouseLeave }
    onMouseEnter={()=>{setactivecls(item?.id)}}
    onMouseLeave={()=>{setactivecls("")} }
     >
       <div
                            className=""
                            style={{ marginRight: "12px", marginBottom: "3px" }}
                            
                            >
                            <div
                              className="product-box product-box2"
                              style={{ paddingRight: "0px"}}
                              onClick={() => {
                                // nvg("/productdetails", {
                                //   state: {
                                //     id: item.id,
                                //     pname: item.title,
                                //     categoryid: item.id,
                                //     pagename: item.title,
                                //   },
                                // });
                                console.log("abckddkdkd",item.id,item.title)
                              }}
                            >
                              
                             
                              <div className="product-imgbox2new" 
                              style={{position: "relative", overflow: "hidden"}}
                              onClick={() => {
                                transfer(item.id, item.title);
                              }} >
                              {item.stockrecords[0]?.num_in_stock <= 0 && (<div className="overlay" onClick={() => {
                                                    transfer(item.id, item.title);
                                                  }}></div>)}
                                              {item.stockrecords[0]?.num_in_stock <= 0 && (
                                                <div className="out-of-stock" style={{ backgroundColor: `#${bgColor}`}}
      >Out of Stock</div>
                                              )}
                                <div className="product-front">
                                  <a href="javascript:void(0)">
                                    <img src={lowestOrderImage?.original} alt="" />
                                  </a>
                                </div>
      
                                {/* <div className="on-sale1">on sale</div> */}
                              </div>
                              <div className="product-detail product-detail2">
                                {/* <p>{item?.id}</p>
                              
                                <p>{hoverRef.current[1]} id</p>
                                <p>{hoverRef.current[0]} bool</p> */}


                                <a href="javascript:void(0)">
                                <div 
  style={{ position: "relative", display: "inline-block", maxWidth: "240px" }} 
  onMouseEnter={() => { hoverRef.current = [true, item?.id]; }}
  onMouseLeave={() => { hoverRef.current = [false, null]; }}
>
  {/* Title */}
  <h6
    className="price-title catbox2"
    style={{
      color:
      activecls === item?.id
          ? "#808080"
          : "black",
      // color:
      //   hoverRef.current[0] && hoverRef.current[1] === item?.id
      //     ? "#808080"
      //     : "black",
      fontSize: "14px",
      fontWeight: "100",
      height: "40px",
      lineHeight: "20px",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 2,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "normal",
      maxWidth: "240px",
    }}
  >
   <span style={{color:'green'}}> {`${item?.attributes?.brand ? item?.attributes?.brand + ": " : ""}`}</span>{item?.title}
  </h6>

  {/* Tooltip (Full Title) */}
  {activecls === item?.id && (
    <span
      style={{
        position: "absolute",
        bottom: "50px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fontSize: "10px",
        fontWeight: "400",
        textAlign: "center",
        borderRadius: "5px",
        padding: "6px 10px",
        zIndex: 10,
        width: "max-content",
        maxWidth: "250px",
        whiteSpace: "normal",
        wordWrap: "break-word",
        opacity: 1,
        transition: "opacity 0.2s ease-in-out",
        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
      }}
    >
      {`${item?.attributes?.brand ? item?.attributes?.brand + ": " : ""}${item?.title}`}
    </span>
  )}
</div>

                                  {/* <h6
                                    className="price-title catbox2"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color:  'black',
                                      height: "20px",
                                      display: "-webkit-box",
                                      WebkitLineClamp: "1",
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {item?.attributes?.brand}
                                  </h6>
                                  <h6
                                    className="price-title "
                                    style={{
                                      fontSize: "14px",
                                      color:
                                      hoverRef.current[0] && hoverRef.current[1] === item?.id
                                        ? '#808080'
                                        : "black",
                                    border :   hoverRef.current[0] && hoverRef.current[1] === item?.id
                                    ? '#808080'
                                    : "black",
                                      fontWeight: "600",
                                      display: "-webkit-box",
                                      WebkitLineClamp: "1",
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                    }}
                                  
                                  >
                                    {item?.title}
                                  </h6>{" "} */}
                                </a>
                                
                                <h5
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    color: "black",
                                  }}
                                >
                                  <span style={{color:'#029102',textDecoration:'none'}}> MRP:</span>
                                  {new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0, 
  maximumFractionDigits: 0, 
}).format(parseInt(item.stockrecords[0]?.price))}
                              
                                  {item.stockrecords[0]?.discount == 0 ? (
                                    ""
                                  ) : (
                                    <span
                                      style={{
                                        fontSize: "13px",
                                        color: "#c1c1c1",
                                        lineHeight: "20px",
                                        textDecoration: "line-through",
                                        paddingLeft: "3px",
                                        fontWeight: "400",
                                      }}
                                    >
                                      
                                      {new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0, 
  maximumFractionDigits: 0, 
}).format(parseInt(item.stockrecords[0]?.mrp))}
                                      {/* ₹{parseInt(item.stockrecords[0]?.mrp)} */}
                                    </span>
                                  )}
                                  {item.stockrecords[0]?.discount == 0 ? (
                                    ""
                                  ) : (
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        textDecoration: "none",
                                        color: "#388e3c",
                                        lineHeight: "20px",
                                        paddingLeft: "3px",
                                        fontWeight: "400",
                                      }}
                                    >
                                      
                                      {item.stockrecords[0]?.discount_type == "amount"
                                        ? `(₹${item.stockrecords[0]?.discount} off)`
                                        : `(${item.stockrecords[0]?.discount} %off)`}
                                    </span>
                                  )}
                                </h5>
                              </div>
                            </div>
                          </div>
    </div>
  )
}

export default NewCorousel
